import React from 'react';
import PropTypes from 'prop-types';

const ImageButton = ({ label, imageSrc, onClick, isLoading = false, inputClassName = "image-btn-unselected" }) => {
    ImageButton.propTypes = {
      label: PropTypes.string.isRequired,
      imageSrc: PropTypes.string.isRequired,
      onClick: PropTypes.func.isRequired,
      isLoading: PropTypes.bool.isRequired,
      inputClassName: PropTypes.string.isRequired
    };
    return (
      <button className= {inputClassName} type="button" onClick={() => onClick()} disabled={isLoading}>
        {isLoading ? (
                <React.Fragment>
                    <i className="la la-spinner la-spin" />
                    <label>{label}</label>
                </React.Fragment>
            ) : (
                <React.Fragment>
                    <img
                      src={imageSrc}
                      className="harm-watch-feed-icon icon-filter"
                      alt={label}
                    />
                    <label>{label}</label>
                </React.Fragment>
            )}
      </button>
    );
};

export default ImageButton;



// WEBPACK FOOTER //
// ./src/features/shared-components/UI-components/ImageButton.js